/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import GeneralFilter from "../../Shared/Filter/GeneralFilter";
import { resetEventFilters, setSelectedFromEventTime, setSelectedToEventTime } from "../../../store/filters/alarms/reducers";
import { useAlarmsFilter } from "./hooks";
import { alarmFilterEventFromTimeSelector, alarmFilterEventToTimeSelector } from "../../../store/filters/alarms/selectors";

export const AlarmsFilter = () => {
  const { dispatch, eventFilters, formControlSx, searchTooltip } = useAlarmsFilter();


  return (
    <>
      <GeneralFilter dispatch={dispatch} filters={eventFilters} formControlSx={formControlSx} resetFilters={resetEventFilters} searchTooltip={searchTooltip} 
      searchScope="alarms"
      timeFilterConfig={{
          fromSelector: alarmFilterEventFromTimeSelector,
          toSelector: alarmFilterEventToTimeSelector,
          setFrom: setSelectedFromEventTime,
          setTo: setSelectedToEventTime,
        }}
        />
    </>
  );
};

export default AlarmsFilter;
